module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Calculator_16"],"path":[{"$":{"d":"M3,0V16H13V0ZM6,14H4V12H6Zm0-3H4V9H6ZM6,8H4V6H6Zm3,6H7V12H9Zm0-3H7V9H9ZM9,8H7V6H9Zm3,6H10V12h2Zm0-3H10V9h2Zm0-3H10V6h2Zm0-4H4V2h8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Calculator_16.svg
// module id = t/tK
// module chunks = 1